export default __webpack_public_path__ + "static/media/cloud9-4.d934c219.png";